import type { SVGProps } from "react";
export const PlayVideoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className="fill-current"
    {...props}
  >
    <path
      d="M16 8.8C16 4.82355 12.7765 1.6 8.8 1.6C4.82355 1.6 1.6 4.82355 1.6 8.8C1.6 12.7765 4.82355 16 8.8 16C12.7765 16 16 12.7765 16 8.8ZM17.6 8.8C17.6 13.6601 13.6601 17.6 8.8 17.6C3.93989 17.6 0 13.6601 0 8.8C0 3.93989 3.93989 0 8.8 0C13.6601 0 17.6 3.93989 17.6 8.8Z"
      fill="currentColor"
    />
    <path
      d="M6.8 12.4L12.4 8.8L6.8 5.2V12.4Z"
      fill="currentColor"
    />
  </svg>
);
